import { useEffect, useState } from 'react';
import { Option } from 'models/Global';
import { Enterprise } from 'models/Enterprises';
import api from 'api';
import { getUserFullName } from 'utils';

export default function useEnterpriseBrokers(enterprise: Partial<Enterprise>) {
  const [brokers, setBrokers] = useState<Option[]>([]);

  useEffect(() => {
    if (!enterprise?._id) return;

    (async () => {
      try {
        const { data } = await api.enterprises.getEnterpriseMembers(
          enterprise?._id,
        );

        setBrokers(
          data.map(({ colleagueId, firstName, lastName }) => ({
            value: colleagueId,
            label: getUserFullName(firstName, lastName),
          })),
        );
      } catch (e) {
        return;
      }
    })();
  }, [enterprise?._id]);

  return brokers;
}
